import { useParams } from 'react-router-dom'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import MailBox from "./MailBox"
import MailBoxForMobile from './MailBoxForMobile'
import SupportForMobile from './SupportForMobile'


const MailBoxMain = () => {
    const { id } = useParams()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('mobile'))

    if (isMobile) {
        if (id === "support") {
            return <SupportForMobile />
        }
        else {
            return <MailBoxForMobile />
        }
    }
    else {
        return <MailBox />
    }
}

export default MailBoxMain